import { Alert, Snackbar } from "@mui/material";
import Slide from "@mui/material/Slide";

interface RequirementsAppliedSnackbarProps {
  open: boolean;
  onClose: VoidFunction;
}

export function RequirementsAppliedSnackbar(
  props: RequirementsAppliedSnackbarProps,
) {
  const { open, onClose } = props;

  return (
    <Snackbar
      id="customerRequierementsPopulatedSnackbar"
      open={open}
      autoHideDuration={2000}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      TransitionComponent={Slide}
    >
      <Alert onClose={onClose} severity="success" sx={{ width: "100%" }}>
        Requirements applied!
      </Alert>
    </Snackbar>
  );
}
